import React from 'react'

import ProcessesListLoader from './_load/ProcessesListLoader'
import ProcessesGrid from './ProcessesGrid'

const ProcessesSection = () => {
  return (
    <ProcessesListLoader>
      <ProcessesGrid />
    </ProcessesListLoader>
  )
}

export default ProcessesSection
